/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { LanguageHelp } from '../../../helpers/LanguageHelper'
import { KTSVG } from '../../../helpers'

type Props = {
  className?: string
  className_Label?: string
  functionSubmit?: any
  selectedChannelType?: string
  isShowOnlyConversationChannel?: boolean // Only show conversation/meeting channels if true
  caretUsage?: boolean
  renderAsNativeSelect?: boolean
}

const changeDropDownText = (e: React.MouseEvent<Element, MouseEvent>) => {
  const target = e.target as HTMLInputElement;
  target.parentElement!.parentElement!.parentElement!.children[0].children[0].textContent = target.textContent
}


const webchatPlatformFilterOption = { key: 'Chatbot', label: LanguageHelp('Webchat Conversations') }

const socialPlatformFilterOptionDefs: { key: string; labelKey: string }[] = [
  { key: 'Twitter Mentions', labelKey: 'Twitter Mentions' },
  { key: 'Facebook Mentions', labelKey: 'Facebook Mentions' },
  { key: 'Instagram Mentions', labelKey: 'Instagram Mentions' },
  { key: 'Youtube Mentions', labelKey: 'Youtube Mentions' },
  { key: 'Reddit Mentions', labelKey: 'Reddit Mentions' },
  { key: 'TikTok Mentions', labelKey: 'TikTok Mentions' },
  { key: 'Linkedin Mentions', labelKey: 'Linkedin Mentions' },
  { key: 'News Mentions', labelKey: 'News Mentions' },
  { key: 'Şikayetvar Mentions', labelKey: 'Şikayetvar Mentions' },
  { key: 'Ekşi Sözlük Mentions', labelKey: 'Ekşi Sözlük Mentions' },
  { key: 'Twitter Comments', labelKey: 'Twitter Comments' },
  { key: 'Facebook Comments', labelKey: 'Facebook Comments' },
  { key: 'Instagram Comments', labelKey: 'Instagram Comments' },
  { key: 'Youtube Comments', labelKey: 'Youtube Comments' },
  { key: 'TikTok Comments', labelKey: 'TikTok Comments' },
  { key: 'Linkedin Comments', labelKey: 'Linkedin Comments' },
  { key: 'Twitter Sharings', labelKey: 'Twitter Sharings' },
  { key: 'Facebook Sharings', labelKey: 'Facebook Sharings' },
  { key: 'Instagram Sharings', labelKey: 'Instagram Sharings' },
  { key: 'Youtube Sharings', labelKey: 'Youtube Sharings' },
  { key: 'TikTok Sharings', labelKey: 'TikTok Sharings' },
  { key: 'Linkedin Sharings', labelKey: 'Linkedin Sharings' },
]

const socialPlatformFilterOptions = socialPlatformFilterOptionDefs.map(({ key, labelKey }) => ({
  key,
  label: LanguageHelp(labelKey),
}))

// Meeting analysis (Meet/Zoom/Teams) uses a single Chrome extension channel (type 100).
const conversationPlatformLabelKeys: Record<string, string> = {
  Conversations_OnlineMeetingNotes: 'Online Meeting Conversations',
  Conversations_Twitter: 'Twitter Conversations',
  Conversations_Instagram: 'Instagram Conversations',
  Conversations_FacebookMessenger: 'Facebook Conversations',
  Conversations_WhatsApp: 'WhatsApp Conversations',
  Conversations_Slack: 'Slack Conversations',
  Conversations_Skype: 'Skype Conversations',
}

const conversationPlatformOptions = [
  webchatPlatformFilterOption,
  ...Object.entries(conversationPlatformLabelKeys).map(([key, labelKey]) => ({
    key,
    label: LanguageHelp(labelKey),
  })),
]

const conversationChannelTypes = [
  { key: 'All Platforms', label: LanguageHelp('All Platforms') },
  ...conversationPlatformOptions,
]

const conversationPlatformsForReports = conversationPlatformOptions

export { conversationPlatformsForReports, socialPlatformFilterOptions }

// All channel types (original list + conversation platforms for report filtering)
const allChannelTypes = [
  { key: 'All Platforms', label: LanguageHelp('All Platforms') },
  { key: 'Api', label: LanguageHelp('Api') },
  ...socialPlatformFilterOptions,
  ...conversationPlatformsForReports,
];

const DropdownFilterChannels: FC<Props> = ({ 
  className = '', 
  className_Label = 'btn btn-light btn-active-light-primary btn-sm',
  functionSubmit,
  selectedChannelType = 'All Platforms',
  isShowOnlyConversationChannel = false,
  caretUsage = true,
  renderAsNativeSelect = false,
}) => {
  // Select which channel types to show
  const channelTypesToShow = isShowOnlyConversationChannel ? conversationChannelTypes : allChannelTypes;
  const selectedPlatformLabel = channelTypesToShow.find((item) => item.key === selectedChannelType)?.label ?? selectedChannelType;

  if (renderAsNativeSelect) {
    return (
      <div className={className}>
        <select
          className={className_Label || 'form-select form-select-solid fw-bolder'}
          value={selectedChannelType}
          onChange={(e) => functionSubmit?.(e.target.value, 'channeltype')}
        >
          {channelTypesToShow.map((item) => (
            <option key={item.key} value={item.key}>{item.label}</option>
          ))}
        </select>
      </div>
    )
  }

  return (
    <div className={className}>
      <a href='#' className={className_Label} data-kt-menu-trigger='click' data-kt-menu-placement='bottom-end'>
        <div style={{ display: 'unset' }}>{selectedPlatformLabel}</div>
        {caretUsage && <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-5 m-0' />}
      </a>
      {/* begin::Menu */}
      <div className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-250px py-4 scroll-y mh-250px px-2' data-kt-menu='true'>
        {/* begin::Menu item */}
        {channelTypesToShow.map((item) => (
          <div className='menu-item px-3' key={item.key}>
            <a className='menu-link px-3' onClick={(e) => { functionSubmit(item.key, 'channeltype'); changeDropDownText(e); }}>
              {item.label}
            </a>
          </div>
        ))}
        {/* end::Menu item */}
      </div>
      {/* end::Menu */}
    </div>
  )
}

export { DropdownFilterChannels }
